module.exports = __webpack_public_path__ + "img/ventas-to-check.faf69706.png";